import {
  AssignmentOutlined,
  CloudSyncOutlined,
  FilterDramaOutlined,
  NoteAddOutlined,
} from "@mui/icons-material";
import { lazy, Suspense, useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import LoadingFallback from "../../../components/LoadingFallback";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../redux/actions/sidebarActions";

// Lazy load heavy components
const DropdownButton = lazy(
  () => import("../../../components/ui/buttons/DropdownButton")
);
const LoanBulkFileUploader = lazy(
  () => import("../shared/LoanBulkFileUploader")
);

const SalesforceIntegrationButton = () => {
  const dispatch = useDispatch();
  const [showUpload, setShowUpload] = useState(false);

  const handleUploadClose = useCallback(() => {
    setShowUpload(false);
  }, []);

  const handleUploadClick = useCallback(() => {
    setShowUpload(true);
  }, []);

  const handleSizerUploadClick = useCallback(() => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.SIZER_UPLOAD));
  }, [dispatch]);

  const options = [
    {
      label: "Create Salesforce Opportunity",
      onClick: handleUploadClick,
      disabled: true,
      icon: <NoteAddOutlined />,
    },
    {
      label: "Sync with Salesforce",
      onClick: handleSizerUploadClick,
      disabled: true,
      icon: <CloudSyncOutlined />,
    },
    {
      label: "Assign to Existing Salesforce Opportunity",
      onClick: handleSizerUploadClick,
      disabled: true,
      icon: <AssignmentOutlined />,
    },
  ];

  // Only show if admin
  return;

  return (
    <>
      <Suspense fallback={<LoadingFallback />}>
        <LoanBulkFileUploader show={showUpload} onClose={handleUploadClose} />

        <DropdownButton
          size="small"
          // size="large"
          endIcon={<FilterDramaOutlined />}
          variant="outlined"
          options={options}
        >
          Salesforce Integration
        </DropdownButton>
      </Suspense>
    </>
  );
};

export default SalesforceIntegrationButton;
